module.exports = "$(document).ready(function() {\n\n});\n\n"


//////////////////
// WEBPACK FOOTER
// /data/app/rdc-next/~/raw-loader!./mortgage/v7/navigate/footer.js
// module id = 1269
// module chunks = 49 50